import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign } from "helpers/helpers"

function SummarySalary({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function searchWithFilter() {
		var filterUrl = "/employee-salary"
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={true}
				animation={false}
				centered
				size="xl"
				onHide={() => setActiveModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('salary')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th>#</th>
									<th style={{ 'width': '40%' }}>{t('employee')}</th>
									<th className="text-end" >{t('salary')}</th>
									<th className="text-end">{t('sales')}</th>
									<th className="text-end">{t('gross_income')}</th>
									<th className="text-end">KPI {t('sales')}</th>
									<th className="text-end">{t('accrued_total')}</th>
									<th className="text-end">{t('general_payments')}</th>
									<th className="text-end">{t('to_pay')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td>{item.first_name}</td>
										<td className="text-nowrap text-end">{formatMoney(item.salary)}</td>
										<td className="text-nowrap text-end">
											{formatMoney(item?.sales)}
										</td>
										<td className="text-nowrap text-end">
											{formatMoney(item?.gross)}
										</td>
										<td className="text-nowrap text-end">{formatMoney(item.bonus)}</td>
										<td className="text-nowrap text-end">{formatMoney(item.accrued)}</td>
										<td className="text-nowrap text-end">
											{formatMoney(item?.total_amount)}
										</td>
										<td className="text-nowrap text-end">
											{formatMoney(item?.salary_one_day)}
										</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.overall_salary)}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.overall_sales)}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.overall_gross)}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.overall_bonus)}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.overall_accrued)}</b></td>
									<td className="text-end text-nowrap">
										<b className="text-success">{formatMoney(data.overall_total_amount)}</b>
									</td>
									<td className="text-nowrap text-end"><b>{formatMoney(data.overall_salary_one_day)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default SummarySalary